import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import {
  Button,
  IconButton,
  InputAdornment,
  Box,
  TextField,
  Tooltip
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import queryString from 'query-string';
// import { getPublicOnlineBookingPageAPI } from 'src/content/OnlineBooking/api';

const PublicPromoCodeInput = ({
  tenantId,
  onlineBookingPageId,
  serviceId,
  isCheckingPromoCode,
  setIsCheckingPromoCode,
  setValidPromoCode
}) => {
  const [codeInput, setCodeInput] = useState('');
  // const [isSubmitting, setIsSubmitting] = useState(false); // move to parent component
  const [outcome, setOutcome] = useState('untouched');

  const handleRemoveCodeInput = () => {
    setCodeInput('');
    setValidPromoCode([]);
    setIsCheckingPromoCode(false);
    setOutcome('untouched');
  };

  const parsed: any = Object.fromEntries(
    Object.entries(queryString.parse(location.search)).map(([k, v]) => [
      k.toLowerCase(),
      v
    ])
  );

  const onSubmitCheckPromoCode = async () => {
    setIsCheckingPromoCode(true);
    // console.log(codeInput);

    const graphQLquery = {
      query: `query CheckServicePromoCode($tenantId: ID!, $onlineBookingPageId: ID!, $serviceId: ID!, $code: String!) {\n  checkServicePromoCode(tenantId: $tenantId, onlineBookingPageId: $onlineBookingPageId, serviceId: $serviceId, code: $code) {\n    id\n    type\n   startTime\n    endTime\n     }\n}\n`,
      variables: {
        tenantId: tenantId,
        onlineBookingPageId: onlineBookingPageId,
        serviceId: serviceId,
        code: codeInput
      }
    };

    axios
      .post(process.env.REACT_APP_AWS_GRAPHQL_API, graphQLquery, {
        headers: {
          // Need to change API key for different stack.
          'x-api-key': process.env.REACT_APP_AWS_CONFIRMATION_API,
          accept: 'application/json, text/plain, */*',
          'accept-language': 'en-GB,en;q=0.9,en-US;q=0.8,vi;q=0.7',
          'content-type': 'application/json'
        }
      })
      .then((res) => {
        // console.log(res);
        if (
          res.status === 200 &&
          res.data.data?.checkServicePromoCode &&
          res.data.data.checkServicePromoCode?.type === 'Discount'
        ) {
          // console.log('success');
          setOutcome('success');
          setValidPromoCode([res.data.data.checkServicePromoCode.id]);
          setIsCheckingPromoCode(false);
        } else {
          // console.log('error');
          setOutcome('fail');
          setIsCheckingPromoCode(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setOutcome('fail');
        setIsCheckingPromoCode(false);
        // setError('Looks like something went wrong.');
      });
  };

  // this is to pre-fill and auto-validate promo code.
  useEffect(() => {
    if (parsed?.promo) {
      // console.log('promo passed');
      setCodeInput(parsed?.promo.toUpperCase());

      setIsCheckingPromoCode(true);
      // console.log(codeInput);

      const graphQLquery = {
        query: `query CheckServicePromoCode($tenantId: ID!, $onlineBookingPageId: ID!, $serviceId: ID!, $code: String!) {\n  checkServicePromoCode(tenantId: $tenantId, onlineBookingPageId: $onlineBookingPageId, serviceId: $serviceId, code: $code) {\n    id\n    type\n   startTime\n    endTime\n     }\n}\n`,
        variables: {
          tenantId: tenantId,
          onlineBookingPageId: onlineBookingPageId,
          serviceId: serviceId,
          code: parsed?.promo.toUpperCase()
        }
      };

      axios
        .post(process.env.REACT_APP_AWS_GRAPHQL_API, graphQLquery, {
          headers: {
            // Need to change API key for different stack.
            'x-api-key': process.env.REACT_APP_AWS_CONFIRMATION_API,
            accept: 'application/json, text/plain, */*',
            'accept-language': 'en-GB,en;q=0.9,en-US;q=0.8,vi;q=0.7',
            'content-type': 'application/json'
          }
        })
        .then((res) => {
          // console.log(res);
          if (
            res.status === 200 &&
            res.data.data?.checkServicePromoCode &&
            res.data.data.checkServicePromoCode?.type === 'Discount'
          ) {
            // console.log(res);
            // console.log('success');
            setOutcome('success');
            setValidPromoCode([res.data.data.checkServicePromoCode.id]);
            setIsCheckingPromoCode(false);
          } else {
            console.log('Error');
            setOutcome('fail');
            setIsCheckingPromoCode(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setOutcome('fail');
          setIsCheckingPromoCode(false);
          // setError('Looks like something went wrong.');
        });
    }
  }, [parsed?.promo]);

  // console.log(servicesList);
  return (
    <>
      <Box display="flex" justifyContent={'flex-end'} sx={{ mt: 2 }}>
        <Box>
          <TextField
            label="Promo Code"
            variant="outlined"
            size="medium"
            sx={{ mr: 1, width: 160 }}
            // color={
            //   outcome === 'success'
            //     ? 'success'
            //     : outcome === 'fail'
            //     ? 'error'
            //     : 'secondary'
            // }
            disabled={outcome === 'success'}
            value={codeInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setCodeInput(event.target.value.toUpperCase());
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {/* <IconButton aria-label="success" edge="end"> */}
                  {outcome === 'success' ? (
                    <Tooltip placement="top-start" title={'Applied!'}>
                      <CheckCircleOutlineIcon color="success" />
                    </Tooltip>
                  ) : outcome === 'fail' ? (
                    <Tooltip placement="top-start" title={'Invalid!'}>
                      <ErrorOutlineIcon color="error" />
                    </Tooltip>
                  ) : null}
                  {/* </IconButton> */}
                </InputAdornment>
              )
            }}
          />
        </Box>

        {outcome !== 'success' ? (
          <Button
            variant="outlined"
            sx={{ my: 1 }}
            disabled={codeInput === '' || isCheckingPromoCode}
            onClick={() => onSubmitCheckPromoCode()}
          >
            Apply
          </Button>
        ) : null}

        {outcome === 'success' ? (
          <Button
            variant="outlined"
            color="error"
            sx={{ my: 1 }}
            disabled={codeInput?.length === 0 || isCheckingPromoCode}
            onClick={handleRemoveCodeInput}
          >
            Remove
          </Button>
        ) : null}
      </Box>
    </>
  );
};

export default PublicPromoCodeInput;
